import {Component, ViewChild, ViewEncapsulation, Input, Output, EventEmitter, Injectable, OnChanges } from '@angular/core';
import { ValueAccessorBase } from '../default-class/value-accessor';
import { NgModel, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { TranslatedLuxonDateAdapter, LUXON_DATE_FORMAT } from './luxon-date-adapter';
import { DateTime } from 'luxon';

// Month translations moved to luxon-date-adapter.ts

// TranslatedLuxonDateAdapter is now imported from luxon-date-adapter.ts

// MY_DATE_FORMAT is replaced by LUXON_DATE_FORMAT from luxon-date-adapter.ts

@Component({
    selector: 'tidy-datepicker',
    templateUrl: 'datepicker.component.html',
    styleUrls: ['./datepicker.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: DatePickerComponent,
            multi: true,
        },
        { provide: DateAdapter, useClass: TranslatedLuxonDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: LUXON_DATE_FORMAT }
    ],
    standalone: false
})
export class DatePickerComponent extends ValueAccessorBase<Date | string> implements OnChanges {
  @Input() public label: string;
  @Input() public placeholder: string;
  @Input() public icon: string;
  @Input() public form: any;
  @Input() public submitted: boolean;
  @Input() public errorMessage: string;
  @Input() public noPastDates: boolean;
  @Input() public minDate: string | Date;
  @Input() public minSameDate = false;
  @Output() optionChange: EventEmitter<Date | string> = new EventEmitter<Date | string>();
  @ViewChild(NgModel, {static: false}) model: NgModel;

  calendarOpened = false;
  touchedState = false;

  constructor() {
    super();
  }

  changeDate(e) {
    if (e.value && typeof e.value.toJSDate === 'function') {
      this.value = e.value.toJSDate();
    } else if (e.value && typeof e.value.toDate === 'function') {
      this.value = e.value.toDate();
    } else {
      this.value = e.value;
    }
    this.optionChange.emit(this.value);
  }

  changeTouch = () => {
    this.touchedState = true;
  }

  ngOnChanges() {
    if (this.noPastDates) {
      this.minDate = new Date();
      this.minDate.setHours(0, 0 , 0, 0);
    }

    if (this.beforeThanMinDate() && !this.minSameDate) {
      this.value = undefined;
    }
  }

  beforeThanMinDate() {
    const dateValue = new Date(this.value);
    const dateMin = new Date(this.minDate);

    return dateValue < dateMin;
  }

  toggleMatPicker() {
    this.calendarOpened = !this.calendarOpened;
  }

  calendarClosed() {
    this.calendarOpened = false;
  }
}
